

























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import { RowTable } from "@/typings/BRowTable";
import Helpers from "@/helpers/helper";
import Persona from "../../models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import SolicitudCambioComposicionFamiliar, {
  SolicitudCambioComposicionFamiliarCorreccion,
  SolicitudCambioComposicionFamiliarDocumento
} from "@/models/tramite/solicitud-cambio-composicion-familiar/";
import { Utils } from "@/core/Utils";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import NameValue from "@/models/nameValue.model";
import TipoTramite from "@/models/tipoTramite";
@Component
export default class CambioComposicionFamiliarCorreccion extends BaseVue {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;
  @Prop() readonly codigoDocAdicionales!: string;

  miembroTableConfig!: BTableConfig<Miembro>;
  tableData: Miembro[] = [];
  editing = false;
  editingMiembro: Miembro | undefined | null = null;
  editingMiembroModel: Miembro | undefined | null = null;
  editingMiembroToSave: Miembro | null = null;
  nameValue = new NameValue();
  model = new SolicitudCambioComposicionFamiliar();
  constructor() {
    super();
    this.model.correccion = true;
  }
  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId) {
      let contenido = this.content as any;
      if (contenido) {
        contenido.solicitudCambioComposicionFamiliar.hogarId = this.beneficiario.hogarId;
        this.$emit("update:content", contenido);
      }
      return this.beneficiario.hogarId;
    }
    return 0;
  }
  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }

  created() {
    let props = [];
    props.push(
      new TipoTramiteComponentProp(
        "codigoDocAdicionales",
        "string",
        true,
        "Código de docs. adicionales"
      )
    );
    let contenido = this.content as any;
    let main = (contenido.solicitudCambioComposicionFamiliar = this.copy(
      this.model
    ));
    main.correccion = true;
    contenido.solicitudCambioComposicionFamiliar = main;
    this.$emit("update:content", contenido);
    this.$emit("render", props);
  }

  destroyed() {
    if (this.content) {
      let contenido = this.content as any;
      if (contenido.solicitudCambioComposicionFamiliar)
        delete contenido.solicitudCambioComposicionFamiliar;

      this.$emit("update:content", contenido);
    }
  }
  mapModel(obj: any) {
    let m = this.map<Miembro>(obj);
    let p = m.persona as Persona;
    (m.persona as Persona).nombreCompleto = `${p.nombre1} ${p.nombre2} ${p.apellido1} ${p.apellido2}`;
    return m;
  }

  showModalEditMiembro(id: number, row: Miembro) {
    this.editingMiembroModel = this.mapModel(row);
    this.editingMiembro = this.mapModel(row);
    this.editing = true;
  }
  editModelChange(value: Miembro) {
    this.editingMiembroToSave = value;
  }
  restartEdit() {
    this.editingMiembro = this.mapModel(this.editingMiembroModel);
  }
  getMember(m: any) {
    let val = new SolicitudCambioComposicionFamiliarCorreccion(
      this.hogarId,
      m.id,
      m.personaId
    );
    if (m.persona) {
      let ignore = [
        "id",
        "deleted",
        "createdDate",
        "updatedDate",
        "createdBy",
        "updatedBy",
        "cedula",
        "fechaNacimiento"
      ];
      Utils.mapToObject(m.persona, val, { ignore: ignore });
      if (m.persona.cedula) val.cedula = m.persona.cedula.replace(/-/g, "");
      else val.cedula = undefined;
      if (m.persona.fechaNacimiento)
        val.fechaNacimiento = new Date(m.persona.fechaNacimiento.toString());
    }
    val.codHogar = m.codigoHogar;
    val.parentescoId = m.parentescoId;
    val.parentescoNombre = m.parentescoNombre;
    val.persona = m.persona;
    val.documentos = m.documentos;
     val.miembroId = m.id || m.miembroId;
    return val;
  }
  closeEdit() {
    this.editing = false;
    this.editingMiembro = null;
    this.editingMiembroModel = null;
    this.editingMiembroToSave = null;
  }
  async onSaveEdit() {
    let ref = this.$refs.miembro_edit as any;
    if (ref) {
      let isValid = await ref.isValid();
      if (!isValid) return;
    }
    let index = this.model.miembrosCorregidos.findIndex(
      (x: any) => x.personaId === (this.editingMiembroToSave as Miembro).personaId
    );
    let m = this.mapModel(this.editingMiembroToSave);
    this.model.miembrosCorregidos.splice(index, 1, this.getMember(m));
    this.editing = false;
    this.miembroTableConfig.actions.isEditableRow = (row: Miembro) =>
      !this.model.miembrosCorregidos.some(m => m.personaId === row.personaId);
  }
  onEdit(id: number, miembro: Miembro) {
    if (
      this.model.miembrosCorregidos.some(
        (x: SolicitudCambioComposicionFamiliarCorreccion) => x.miembroId === id
      )
    )
      return;
    let m = this.mapModel(miembro);
    this.model.miembrosCorregidos.push(this.getMember(m));
    this.miembroTableConfig.actions.isEditableRow = (row: Miembro) =>
      !this.model.miembrosCorregidos.some(m => m.personaId === row.personaId);
  }
  removeMiembro(index: number, value: Miembro) {
    this.model.miembrosCorregidos.splice(index, 1);
    this.miembroTableConfig.actions.isEditableRow = (row: Miembro) =>
      !this.model.miembrosCorregidos.some(m => m.personaId === row.personaId);
  }
  onLoadTable(config: BTableConfig<Miembro>) {
    this.miembroTableConfig = config;
    this.miembroTableConfig.customEmptyTemplate = true;
  }
  @Watch("model", { deep: true })
  set(model: SolicitudCambioComposicionFamiliar) {
    let contenido = this.content as any;
    if (contenido) {
      contenido.solicitudCambioComposicionFamiliar = this.map(model);
      contenido.solicitudCambioComposicionFamiliar.miembrosCorregidos.forEach(
        (x: any) => delete x.persona
      );
      this.$emit("update:content", contenido);
    }
  }

  onChangeDocs(
    miembro: SolicitudCambioComposicionFamiliarCorreccion,
    tipos: any,
    docs: any[]
  ) {
    miembro.documentos = docs.map(x => {
      let doc = new SolicitudCambioComposicionFamiliarDocumento();
      doc.personaId = miembro.personaId;
      doc.documentoId = x.documentoId;
      doc.documento = x.documento;
      doc.tipoDocumentoId = x.tipoDocumentoId;
      doc.tipoDocumentoNombre = x.tipoDocumentoNombre;
      return doc;
    });
  }
  @Watch("codigoDocAdicionales", { immediate: true })
  async onCodigoDocAdicionalesChange(value: string) {
    if (value) {
      this.nameValue = await new BaseRepository<NameValue>("namevalues").one(
        `codigo="${value}"`
      );
    }
  }

  public async isValid() {
    let isValid = await this.validateCurrentValidator();
    if (!isValid) return false;

    return this.validateRefCollection("documentos");
  }
}
